/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useGoogleFont } from "./composables/useGoogleFont";
import { cn } from "tailwind-variants";

export default function FontPreviewOption({
  textValue,
  fontFamily,
  color,
  optionLabel,
  optionValue,
  isSelected = false,
  isDisabled = false,
  previewType,
  compact = false,
  onSelect,
  ...restProps
}: any) {
  function fontToLoad() {
    return previewType === "font" ? optionValue : fontFamily;
  }

  function displayColor() {
    return previewType === "color" ? optionValue : color;
  }

  function displayFont() {
    return previewType === "font" ? optionValue : fontFamily;
  }

  function secondaryLabel() {
    return previewType === "color" ? `${optionLabel} (${optionValue})` : optionLabel;
  }

  useGoogleFont(fontToLoad());

  function handleClick() {
    if (!isDisabled) {
      onSelect?.();
    }
  }

  function handleKeydown(e: any) {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (!isDisabled) {
      onSelect?.();
    }
  }

  return (
    <div
      {...restProps}
      className={cn(
        "flex cursor-pointer flex-col items-center justify-center border",
        compact ? "w-[140px] rounded-sm p-2" : "w-[180px] rounded-lg p-3",
        isSelected
          ? "border-blue-500 bg-blue-50 hover:bg-blue-100"
          : "border-gray-300 bg-white hover:bg-gray-50",
        isDisabled && "cursor-not-allowed opacity-50"
      )}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      data-testid={`pin-clarify-preview-${optionLabel}`}
      onClick={handleClick}
      onKeyDown={handleKeydown}
    >
      <div
        className={cn(
          "max-w-full truncate text-center font-bold",
          compact ? "px-1 text-sm" : "px-2 text-lg"
        )}
        style={{
          fontFamily: `'${displayFont()}', sans-serif`,
          color: displayColor()
        }}
      >
        {textValue}
      </div>
      <div
        className={cn(
          "max-w-full truncate text-center text-gray-500",
          compact ? "mt-0.5 px-1 text-[10px]" : "mt-1 px-2 text-xs"
        )}
      >
        {secondaryLabel()}
      </div>
    </div>
  );
}

FontPreviewOption.displayName = "FontPreviewOption";
